import React from 'react';
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import StandardDialog from './StandardDialog';
import { Divider, TextField, Typography } from '@material-ui/core';
//import Footer from './Footer';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
// import Title from './../Complements/Title';
import { IconButton } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { history } from '../../helpers/history';
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  root2: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
    position: 'relative',
    minHeight: 300,
  },
  paper: {
    height: 500,
    width: 400,
  },
  control: {
    padding: theme.spacing(2),
  },
  card: {
    height: 500,
    maxWidth: 345,
  },
  card2: {
    height: 100,
    width: 100,
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: '#2E2757',
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  rowIcon: {
    top: '40%'
  },
  titleDark: {
    // color: '#000000',
    fontSize: '0.9rem',
    //fontFamily: 'MyriadPro-Bold'
  },
  numberaccount: {
    color: '#2E2757',
    fontSize: '0.8rem',
    fontWeight: 'bold'
  },
  titleListAccount: {
    color: '#000000',
    fontSize: '0.69rem'
  },
  titleLight: {
    color: '#000000',
    fontSize: '80%',
    //fontFamily: 'MyriadPro-Regular',
  },
  titleGreenBlackPrimary: {
    color: '#2E2757',
    fontSize: '0.8rem',
    //fontFamily: 'MyriadPro-Bold'
  },
  titleGreenBlackSecondary: {
    color: '#000000',
    fontSize: '0.8rem',
    //fontFamily: 'MyriadPro-Regular',
    textAlign: 'center'
  },
  titleselect: {
    fontSize: '70%'
  },
  labelsaldocuenta: {
    color: '#000000',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  saldoaccout: {
    color: '#2E2757',
    fontWeight: 'bold',
    // color: '#7bac2e'
  }
}));
const UserPanelInfoMobile = props => {
  const { user, accountSelected, balances, changeAccount, children, handleAccountChange, dialog, tittle/*, beneficiaries, ownTransfer*/ } = props
  // console.log('props usermobile', props)
  const classes = useStyles();

  /* const handleConvertMask = (numberBeneficiary) => {

    if (numberBeneficiary.length > 4) {

      let resultConvert = ""

      const [a, b, c, d, ...dataConvert] = numberBeneficiary

      for (let y = 0; y < dataConvert.length; y++) {
        resultConvert = resultConvert.concat("X")
      }

      resultConvert = a + b + c + d + resultConvert

      return resultConvert 

    } else {

      return numberBeneficiary

    }

  } */

  const handleConvertMask = (numberBeneficiary) => {

    if (numberBeneficiary.length > 7) {

      let resultConvert = ""

      const [a, b, c, d, ...dataConvert] = numberBeneficiary

      const inicioFin = dataConvert.length - 3

      const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

      for (let y = 0; y < inicioFin; y++) {
        resultConvert = resultConvert.concat("X")
      }

      resultConvert = a + b + c + d + resultConvert + ultimos

      return resultConvert

    } else {

      return numberBeneficiary

    }

  }
  // let suenitosName = ''
  // if (ownTransfer) {
  //   suenitosName = beneficiaries
  //     .filter(ac => ac.type_name === "CUENTA SUEÑITOS" && ac.number === accountSelected.PRODUCTBANKID)
  //     .map(b => b.name)
  // }
  // console.log('suenitosName', suenitosName[0])


  return (
    <Grid item xs={12}  >
      {/* <Title>{tittle.toUpperCase()}</Title> */}
      <Grid xs={12} >
        <Typography><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>{tittle?.toUpperCase()}</Typography>
      </Grid>
      <List className={classes.root}>
        <ListItem>
          <ListItemAvatar>
            <Avatar aria-label="recipe" className={classes.avatar}>
              {user.Name.charAt(0)}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <span className={classes.titleDark}>{user.Name} </span>
            }
            secondary={
              <span>
                <span className={classes.titleLight}>
                  {`${accountSelected.PRODUCTALIAS} - ${handleConvertMask(accountSelected.PRODUCTBANKID)}`}
                </span>
                <br />
                <span className={classes.titleLight}>
                  {`${user.Mail}`}
                </span>
              </span>
            } />
        </ListItem>
        {/* <ListItem button  onClick={ handleAccountChange }>
                                                <ListItemAvatar>
                                                <Avatar aria-label="recipe" >
                                                    <CompareArrowsIcon />
                                                </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Cambiar Cuenta" secondary="" />
                                            </ListItem> */}
      </List>

      <Autocomplete
        id="combo-box-demo"
        classes={{ input: classes.titleselect }}
        value={accountSelected}
        options={balances}
        onChange={(e, nv) => {
          changeAccount(nv)
        }}
        disableClearable
        getOptionLabel={(option) => `${handleConvertMask(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}
        renderOption={(option) => (
          <List className={classes.root}>
            <ListItem>
              <ListItemAvatar>
                <Avatar aria-label="recipe" style={{ backgroundColor: '#014587' }} >
                  <AccountBalanceWalletIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                secondary={
                  <span>
                    <span className={classes.titleListAccount}>{option.PRODUCTALIAS} </span>
                    <span className={classes.numberaccount}>{handleConvertMask(option.PRODUCTBANKID)} </span><br />
                    <span className={classes.titleListAccount}>
                      {`Saldo disponible: `}<b>{`$ ${option.SALDOINT}`}</b>
                    </span>
                  </span>
                }
              />
            </ListItem>
          </List>

        )}
        renderInput={(params) => <TextField {...params} label="Seleccione una cuenta" variant="outlined" fullWidth />}
      />
      <br />
      <FormHelperText className={classes.titleGreenBlackSecondary}>Saldo disponible: <b className={classes.titleGreenBlackPrimary}>$ {accountSelected.SALDOINT}</b></FormHelperText><br />
      <Divider /> <br />
      {children}
      <StandardDialog
        open={dialog}
        title={'Seleccione Cuenta'}
        handleClose={handleAccountChange} >
        <List>
          {
            balances.map(balance => {
              return <ListItem key={balance.tipoCuentaNombre} button
                onClick={() => {
                  handleAccountChange()
                  changeAccount(balance)
                }}>
                <ListItemText
                  primary={`${balance.PRODUCTALIAS}`}
                  secondary={`${handleConvertMask(balance.PRODUCTBANKID)} - $ ${balance.SALDOINT}`} />
              </ListItem>
            })
          }
        </List>
      </StandardDialog>

      {/* <Footer /> */}
    </Grid>
  );
};

UserPanelInfoMobile.propTypes = {

};

export default UserPanelInfoMobile;